module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-1200.176b009f.svg";